import { ReactComponent as Star } from 'icons/star.svg';

const InputRatingStars = ({ value, size }) => {
  return (
    <div className="g-input">
      <div className="input-text-title" style={{ textAlign: 'left' }}>
        Rating Driver
      </div>
      <section className="field-wrapper with-icon" style={{ margin: 0 }}>
        {value ? (
          <p className="input-text-field disable" style={{ display: 'inline-flex', alignItems: 'center' }}>
            <span style={{ marginRight: 10 }}>
              {Array.from({ length: Math.floor(value) }, (_, i) => i).map((idx) => (
                <Star key={`filled-${idx}`} color="#f1a33a" width={size} height={size} />
              ))}
              {Array.from({ length: 5 - Math.floor(value) }, (_, i) => i).map((idx) => (
                <Star key={`empty-${idx}`} color="#edebeb" width={size} height={size} />
              ))}
            </span>
            <span style={{ fontWeight: 800 }}>{value}</span>/5
          </p>
        ) : (
          <p className="input-text-field disable" style={{ display: 'inline-flex', alignItems: 'center' }}>
            Belum Ada Rating
          </p>
        )}
      </section>
    </div>
  );
};

export default InputRatingStars;
